module.exports = __webpack_public_path__ + "img/map-marker-2.df72dd16.png";